export var CustomModelPublishedState;
(function (CustomModelPublishedState) {
    CustomModelPublishedState["DRAFT"] = "draft";
    CustomModelPublishedState["READY"] = "ready";
    CustomModelPublishedState["PUBLISHED"] = "published";
    CustomModelPublishedState["UNPUBLISHED"] = "unpublished";
    CustomModelPublishedState["QUEUED"] = "queued";
    CustomModelPublishedState["TRAINING"] = "training";
    CustomModelPublishedState["FAILED"] = "failed";
    CustomModelPublishedState["CANCELLED"] = "cancelled";
    CustomModelPublishedState["ALL"] = "all";
})(CustomModelPublishedState || (CustomModelPublishedState = {}));
export var CustomModelOrderBy;
(function (CustomModelOrderBy) {
    CustomModelOrderBy["MODIFY_DATE"] = "modifyDate";
    CustomModelOrderBy["CREATE_DATE"] = "createDate";
    CustomModelOrderBy["NAME"] = "name";
})(CustomModelOrderBy || (CustomModelOrderBy = {}));
